/**
 * todo
 * @class sgvizler.SparqlError
 * @memberof sgvizler
 */
export class SparqlError {
    static getErrorMessageWithStatus200(xhr) {
        let patternWikidata = /MalformedQueryException: *(.*)/m; // tslint:disable-line
        let errorWikidata = patternWikidata.exec(xhr.response);
        if (errorWikidata !== null) {
            return errorWikidata[1];
        }
        return xhr.response;
    }
    static getErrorWithOtherStatus(xhr, url) {
        let linkError = '<a href="' + url + '" target="_blank">See this error</a>';
        let message = '';
        if (xhr.status === 0) {
            if (xhr.statusText !== '') {
                message = xhr.statusText + '(' + xhr.status + ')';
            }
            else {
                message = 'You need to allow running insecure content in your navigator or this SPARQL service doesn\'t exist or timed out or CORS violation or no Access-Control-Allow-Origin header set. (see console log)';
            }
        }
        else {
            message = xhr.statusText + '(' + xhr.status + ')';
        }
        return message + '<br/>\n' + linkError;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU3BhcnFsRXJyb3IuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvc2d2aXpsZXIvU3BhcnFsRXJyb3IudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7R0FJRztBQUNILE1BQU0sT0FBTyxXQUFXO0lBRWIsTUFBTSxDQUFDLDRCQUE0QixDQUFFLEdBQW1CO1FBQzNELElBQUksZUFBZSxHQUFHLGlDQUFpQyxDQUFBLENBQUMsc0JBQXNCO1FBRTlFLElBQUksYUFBYSxHQUFHLGVBQWUsQ0FBQyxJQUFJLENBQUMsR0FBRyxDQUFDLFFBQVEsQ0FBQyxDQUFBO1FBQ3RELElBQUksYUFBYSxLQUFLLElBQUksRUFBRTtZQUN4QixPQUFPLGFBQWEsQ0FBQyxDQUFDLENBQUMsQ0FBQTtTQUMxQjtRQUVELE9BQU8sR0FBRyxDQUFDLFFBQVEsQ0FBQTtJQUN2QixDQUFDO0lBQ00sTUFBTSxDQUFDLHVCQUF1QixDQUFFLEdBQW1CLEVBQUMsR0FBVztRQUNsRSxJQUFJLFNBQVMsR0FBRyxXQUFXLEdBQUcsR0FBRyxHQUFHLHNDQUFzQyxDQUFBO1FBQzFFLElBQUksT0FBTyxHQUFHLEVBQUUsQ0FBQTtRQUNoQixJQUFJLEdBQUcsQ0FBQyxNQUFNLEtBQUssQ0FBQyxFQUFFO1lBQ2xCLElBQUksR0FBRyxDQUFDLFVBQVUsS0FBSyxFQUFFLEVBQUU7Z0JBQ3ZCLE9BQU8sR0FBRyxHQUFHLENBQUMsVUFBVSxHQUFHLEdBQUcsR0FBRyxHQUFHLENBQUMsTUFBTSxHQUFHLEdBQUcsQ0FBQTthQUNwRDtpQkFBTTtnQkFDSCxPQUFPLEdBQUcsbU1BQW1NLENBQUE7YUFDaE47U0FDSjthQUFNO1lBQ0gsT0FBTyxHQUFHLEdBQUcsQ0FBQyxVQUFVLEdBQUcsR0FBRyxHQUFHLEdBQUcsQ0FBQyxNQUFNLEdBQUcsR0FBRyxDQUFBO1NBQ3BEO1FBQ0QsT0FBTyxPQUFPLEdBQUcsU0FBUyxHQUFHLFNBQVMsQ0FBQTtJQUMxQyxDQUFDO0NBRUoifQ==